
import { Component, Prop, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { ChatInterface, ProfileMapInterface } from '@/services/QC-V2/chat/interfaces';
import { TagInterface } from '@/services/QC-V2/tag/interfaces';

@Component({
  mixins: [
    Themeable,
  ],
})
export default class ArchiveChatComments extends Vue {
  @Prop() private chat!: ChatInterface;
  @Prop() private profilesMap!: ProfileMapInterface;
  @Prop() private tags!: TagInterface[];

  private collapsed: boolean = true;
  private tagsMap: { [key: number]: TagInterface } = {};

  private created(): void {
    this.tags.forEach((tag) => {
      this.tagsMap[tag.id] = tag;
    });
  }
}
